const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/551122289498?text=Olá!%20Gostaria%20de%20agendar%20uma%20avaliação%20na%20MG%2B%20Saúde%20%26%20Estética."
      target="_blank"
      rel="noopener noreferrer nofollow"
      aria-label="Fale conosco pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer"
      title="Fale conosco pelo WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  );
};

export default WhatsAppButton;
